import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";
import config from "../../config";


const Sidebar = props => {

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">

          <Link to="/" style={{color: config.color.secondaryColor}} className="logo">
             Shan
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(Sidebar);
